import { render } from "./CollectionBlockCollage.vue?vue&type=template&id=96ff1944&scoped=true&ts=true"
import script from "./CollectionBlockCollage.vue?vue&type=script&lang=ts"
export * from "./CollectionBlockCollage.vue?vue&type=script&lang=ts"

import "./CollectionBlockCollage.vue?vue&type=style&index=0&id=96ff1944&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ff1944"]])

export default __exports__